import { ValuePropositionListLayout } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { getCustomBlock } from 'app/components/CustomBlocks'
import Blocks from 'app/helpers/Blocks'

const ValuePropositionListBlock: React.FC<IWPGBlock> = (props) => (
  <ValuePropositionListLayout>
    <Blocks blocks={props.innerBlocks} mapToBlock={getCustomBlock} />
  </ValuePropositionListLayout>
)

export default ValuePropositionListBlock
